import './styles/general.scss';
import "bootstrap";
import {initRules} from "./scripts/rules";
import {pickColor} from "./scripts/color";


initRules()
pickColor()

window.onload = () => {
}

window.onscroll = () => {

}

window.onresize = () => {
}
